import React from 'react'

function StageOne() {
    return (
        <div>
            
        </div>
    )
}

export default StageOne
